module.exports = __webpack_public_path__ + "static/media/22_A.4d77c2b0.png";